export enum ExceptionType {
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
}
